import { Link } from "@StarberryUtils";
import * as React from "react"
import { Button, Container, Row, Col, Accordion, Card, useAccordionToggle } from "react-bootstrap"
//import ScrollAnimation from "react-animate-on-scroll";
import HTMLReactParser from 'html-react-parser';
import Slider from "react-slick";
import { useContext } from "react"
import AccordionContext from "react-bootstrap/AccordionContext"
import "./ImageServiceCards.scss"

// markup
const ImageServiceCards = (props) => {
    function CustomToggle({ children, eventKey, callback }) {
        const currentEventKey = useContext(AccordionContext);
        const decoratedOnClick = useAccordionToggle(eventKey, () =>
            eventKey,
            () => callback && callback(eventKey), 
        );
        const isCurrentEventKey = currentEventKey === eventKey;
        return (
            <div

                className="card-header"
                onClick={decoratedOnClick}
            >
                <i className={isCurrentEventKey ? 'icon-show' : 'icon-plus'}> </i>
                {/* <i className="icon-show"> </i> */}
                {children}
            </div>
        );
    }

    return (
        <React.Fragment>
            <section className="service-card-list sec-pdy-120">
                <Container>
                    <h5 className="section-title">Step by Step</h5>
                    <div>
                        <Row>

                            {props.data && props.data.map((card, i) => {
                                return (
                                    <div class="col-md-6 col-xl-3 service-info-wrap" key={i}>
                                        <div className="service-info">
                                        {card.Image?.url && <div className="service-image"><img loading="lazy" src={card.Image?.url} alt={card?.Image?.alternativeText} /></div>}
                                        {card?.StrapLine && <div className="service-strapline h7">{card?.StrapLine}</div>}
                                            <div className="service-details">
                                                <h5 className="card-title">{card.Title}</h5>
                                                <div className="service-content text-sm">{HTMLReactParser(card.Description)}</div>
                                            </div>

                                        </div>
                                    </div>
                                )
                            })}
                        </Row>
                    </div>
                </Container>
            </section>
        </React.Fragment>   
    )
}
export default ImageServiceCards
